<template>
    <v-switch
        :input-value="value"
        :color="color ? color : 'primary'"
        class="mt-0 pt-0"
        :label="label"
        :disabled="disabled"
        :tabindex="tabindex"
        hide-details
        @change="$emit('change', $event)"
    >
        <template v-slot:label>
            <slot name="label" />
        </template>
        <template v-slot:append>
            <slot name="append" />
        </template>
    </v-switch>
</template>

<script>
export default {
    name: "SwitchButton",
    props: {
        value: {
            type: [Boolean, Number],
            default: false
        },
        label: {
            type: String,
            default: ""
        },
        tabindex: {
            type: [String, Number],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped lang="scss">
    .v-input ::v-deep .v-label {
        font-size: 14px !important;
    }
</style>